import {
    buildLocalBusinessSchema,
    buildProductSchema,
    buildBreadcrumbSchema,
    buildFAQSchema,
    buildSpeakableSchema,
} from "../../../shared/seo/schemas";
import type { SeoHeadProps } from "../../../shared/seo/SeoHead";
import { SITE_BASE } from "../../../shared/seo/siteUrl";

const BASE = SITE_BASE;
const URL = `${BASE}/products/tassels`;

const FAQS = [
    { q: "What types of tassels do you manufacture?", a: "We manufacture silk, cotton, wool, metallic, decorative, curtain, bookmark, furniture, fashion and custom OEM tassels at our Delhi factory. All tassels are handcrafted by experienced artisans." },
    { q: "What is the minimum order quantity for tassels?", a: "Standard MOQ is 50 pieces per design. Custom colour-matched orders begin at 200 pieces. Wholesale discounts apply above 500 pieces." },
    { q: "Do you export tassels from India?", a: "Yes — we export to USA, UK, EU, Germany, France, UAE, Australia and 50+ other countries. Full export documentation, HS Code 5808.90, ISO quality certification provided." },
    { q: "Can you make custom tassels with our branding?", a: "Yes — OEM and private-label tassel manufacturing is a core service. Custom colours, sizes, materials, branded hang tags and packaging available. Min 300 pcs for branded orders." },
    { q: "How much do wholesale tassels cost in India?", a: "Wholesale tassel prices range from ₹15 (cotton, 5cm) to ₹180 (silk, 25cm) per piece. Bulk discounts begin at 500 pieces." },
];

export const TasselsSeo: SeoHeadProps = {
    title: "Tassels Manufacturer Delhi | Wholesale & Export India | Arte Craft India",
    description:
        "Premium handcrafted tassels manufacturer in Delhi. Silk, cotton, wool, metallic. 100+ colours, all sizes. Wholesale & export. Fashion, home decor, crafts. MOQ 50 pcs. Free samples.",
    keywords:
        "tassels manufacturer Delhi, tassel supplier India, silk tassels India, cotton tassels wholesale, metallic tassels manufacturer, wool tassels, curtain tassels India, decorative tassels Delhi, bookmark tassels supplier, custom tassels OEM, tassel exporter India, bulk tassels India, tassel factory Delhi",
    canonical: URL,
    author: "Arte Craft India",
    robots: "index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1",

    ogType: "product",
    ogUrl: URL,
    ogSiteName: "Arte Craft India",
    ogImage: `${BASE}/images/tassels-og.jpg`,
    ogImageAlt: "Handcrafted silk, cotton & metallic tassels from Arte Craft India Delhi manufacturer",
    ogLocale: "en_IN",
    ogLocaleAlternates: ["en_US", "en_GB", "en_AU", "en_AE"],

    twitterCard: "summary_large_image",
    twitterSite: "@ArteCraftIndia",
    twitterCreator: "@ArteCraftIndia",
    twitterImage: `${BASE}/images/tassels-twitter.jpg`,
    twitterImageAlt: "Silk, cotton and metallic tassels from Arte Craft India Delhi",
    twitterLabel1: "Material",
    twitterData1: "Silk · Cotton · Wool · Metallic",
    twitterLabel2: "MOQ",
    twitterData2: "50 pieces — bulk discount from 500 pcs",

    aiBots: true,

    geoRegion: "IN-DL",
    geoPlacename: "Badarpur, New Delhi, India",
    geoPosition: "28.5045;77.2855",

    dublinCore: {
        title: "Tassels Manufacturer Delhi | Wholesale & Export India",
        creator: "Arte Craft India",
        subject: "Tassels, Manufacturing, Wholesale, Export, Delhi, India",
        description: "Premium handcrafted tassels manufacturer in Delhi for wholesale & export.",
        publisher: "Arte Craft India Pvt Ltd, Delhi",
        date: "2026-05-26",
        type: "Service, Product Catalog, Manufacturer Profile",
        language: "en",
        rights: "© 2026 Arte Craft India Pvt Ltd. All rights reserved.",
    },

    hreflangs: [
        { lang: "en-IN", url: URL },
        { lang: "en-US", url: URL },
        { lang: "en-GB", url: URL },
        { lang: "en-AU", url: URL },
        { lang: "en-AE", url: URL },
        { lang: "en", url: URL },
        { lang: "x-default", url: URL },
    ],

    productBrand: "Arte Craft India",
    productAvailability: "in stock",
    productCondition: "new",
    productPriceAmount: "15.00",
    productPriceCurrency: "INR",
    productMaterial: "Silk · Cotton · Wool · Metallic thread",
    productColor: "100+ shades with Pantone matching",
    productSize: "3cm – 25cm + custom",
    productCategory: "Apparel & Accessories > Trims > Tassels",

    themeColor: "#1B4F72",

    jsonLd: [
        buildLocalBusinessSchema(),
        buildProductSchema({
            name: "Tassels — Silk · Cotton · Metallic · Wool · Handcrafted in Delhi",
            sku: "AC-TASSEL-001",
            canonicalUrl: URL,
            imageSlug: "tassels",
            description:
                "Premium handcrafted tassels manufactured in Delhi, India. Silk, cotton, wool and metallic. 100+ colours, all sizes. Wholesale & export.",
            material: "Silk · Cotton · Wool · Metallic thread",
            color: "100+ shades",
            sizes: ["3cm", "5cm", "7cm", "10cm", "12cm", "15cm", "20cm", "25cm"],
            category: "Apparel & Accessories > Trims > Tassels",
            lowPrice: "15",
            highPrice: "180",
        }),
        buildBreadcrumbSchema([
            { name: "Home", url: `${BASE}/` },
            { name: "Products", url: `${BASE}/products` },
            { name: "Tassels", url: URL },
        ]),
        buildFAQSchema(FAQS),
        buildSpeakableSchema(URL, "Tassels Manufacturer Delhi | Wholesale & Export India", "tassels"),
    ],
};
